import {QueryClient} from 'react-query'

import {getUserDataByEmailQuery, GetUserDataByEmailQueryReturnType} from '../../api/user/get-user-data-by-email'

// WBA-4226: the guest step of the booking flow asks this before it books or creates an account, so a
// known email opens the sign-in modal whether "create account" is ticked or not. GET user/check/signIn
// answers `status: true` for any email, so it cannot tell a known email from a new one; this is the
// same lookup the auth modal uses (it answers 400, read as null, for an email nobody holds), and
// fetching it here fills the modal's cache so the modal opens straight on the password step.
// The query itself turns a failed lookup into null; the catch only guards against that ever changing.
export const isKnownAccount = (data: GetUserDataByEmailQueryReturnType | undefined): boolean => Boolean(data?.user)

export const hasAccountForEmail = (queryClient: Pick<QueryClient, 'fetchQuery'>, email: string): Promise<boolean> =>
  queryClient
    .fetchQuery(getUserDataByEmailQuery({query: {email}}))
    .then(isKnownAccount)
    .catch(() => false)
